import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { obterPermissoesUsuario } from '../../../../utils/funcoes';
import { podeIncluir, podeEditar, podeCancelar, podeImprimir, podeEditarItem, podeImprimirItem, podeCancelarItem } from '../../../../hooks/usePermisionMRT';

export function usePermissoesModule(rotina) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const ul = params.get('ul'), li = params.get('li');
    const empresaId = localStorage.getItem('empresaId');
    const pessoaId = localStorage.getItem('pessoaId');
    const token = localStorage.getItem('token');
    const chave = `${rotina}:${empresaId}:${pessoaId}:${ul}:${li}`;
    const [resultado, setResultado] = useState({});
    useEffect(() => {
        let ativo = true;
        if (!token) { navigate('/Auth', { replace: true }); return; }
        if (!ul || !li) { setResultado({ chave, sucesso: false, mensagem: 'Abra esta rotina pelo submenu do sistema.' }); return; }
        obterPermissoesUsuario(pessoaId, empresaId, ul, li).then((r) => {
            if (ativo) setResultado({ ...r, chave });
        }).catch(() => { if (ativo) setResultado({ chave, sucesso: false, mensagem: 'Não foi possível consultar as permissões.' }); });
        return () => { ativo = false; };
    }, [token, chave, empresaId, pessoaId, ul, li, navigate]);
    const pronto = Boolean(token) && resultado.chave === chave;
    const autorizado = pronto && resultado.sucesso === true;
    return {
        pronto, autorizado, mensagem: pronto ? resultado.mensagem : 'Carregando permissões...',
        imprimir: autorizado && podeImprimir(),
        editarItem: autorizado && podeEditarItem(),
        imprimirItem: autorizado && podeImprimirItem(),
        cancelarItem: autorizado && podeCancelarItem(),
        incluir: autorizado && podeIncluir(), editar: autorizado && podeEditar(), cancelar: autorizado && podeCancelar(),
    };
}
